import React, { useState, useCallback } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { SIDEBAR_TOGGLE } from './constants/editorConstants';
import EditorHeader from './components/Header/EditorHeader';
import Toolbar from './components/Toolbar/Toolbar';
import EditorCanvas from './components/Canvas/EditorCanvas';
import LayerPanel from './components/LayerPanel/LayerPanel';

const EditorPage = () => {
  // 오른쪽 사이드바 너비
  const [rightSidebarWidth, setRightSidebarWidth] = useState(280);
  const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(true);

  // 오른쪽 사이드바 너비 리사이즈 핸들러
  const handleSidebarResize = useCallback((e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = rightSidebarWidth;

    const onMouseMove = (moveEvent) => {
      const delta = startX - moveEvent.clientX;
      const newWidth = Math.max(200, Math.min(400, startWidth + delta));
      setRightSidebarWidth(newWidth);
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    document.body.style.cursor = 'ew-resize';
    document.body.style.userSelect = 'none';
  }, [rightSidebarWidth]);

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f3f4f6',
        overflow: 'hidden',
      }}
    >
      {/* 헤더 */}
      <EditorHeader />

      {/* 메인 영역 */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          overflow: 'hidden',
        }}
      >
        {/* 좌측 도구 패널 (아이콘 바 + 설정 패널) */}
        <Toolbar />

        {/* 캔버스 영역 */}
        <EditorCanvas />

        {/* 오른쪽 사이드바 영역 (버튼 + 리사이즈 핸들 + 패널) */}
        <div style={{
          position: 'relative',
          display: 'flex',
          flexShrink: 0,
          width: isRightSidebarOpen ? `${rightSidebarWidth + 4}px` : '0px',
          transition: 'width 0.25s ease',
        }}>
          {/* 사이드바 접기/펼치기 버튼 */}
          <button
            onClick={() => setIsRightSidebarOpen(!isRightSidebarOpen)}
            style={{
              position: 'absolute',
              left: `-${SIDEBAR_TOGGLE.WIDTH}px`,
              top: '50%',
              transform: 'translateY(-50%)',
              width: `${SIDEBAR_TOGGLE.WIDTH}px`,
              height: `${SIDEBAR_TOGGLE.HEIGHT}px`,
              backgroundColor: SIDEBAR_TOGGLE.BG,
              border: '1px solid #e5e7eb',
              borderRight: 'none',
              borderRadius: '6px 0 0 6px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              zIndex: 10,
              color: SIDEBAR_TOGGLE.COLOR,
              transition: 'color 0.15s, background-color 0.15s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = SIDEBAR_TOGGLE.HOVER_BG; e.currentTarget.style.color = SIDEBAR_TOGGLE.HOVER_COLOR; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = SIDEBAR_TOGGLE.BG; e.currentTarget.style.color = SIDEBAR_TOGGLE.COLOR; }}
            title={isRightSidebarOpen ? '패널 접기' : '패널 펼치기'}
          >
            {isRightSidebarOpen ? <FiChevronRight size={SIDEBAR_TOGGLE.ICON_SIZE} strokeWidth={SIDEBAR_TOGGLE.ICON_STROKE_WIDTH} /> : <FiChevronLeft size={SIDEBAR_TOGGLE.ICON_SIZE} strokeWidth={SIDEBAR_TOGGLE.ICON_STROKE_WIDTH} />}
          </button>

          {/* 리사이즈 핸들 */}
          {isRightSidebarOpen && (
            <div
              onMouseDown={handleSidebarResize}
              style={{
                width: '4px',
                backgroundColor: '#e5e7eb',
                cursor: 'ew-resize',
                transition: 'background-color 0.15s',
                flexShrink: 0,
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#3b82f6'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#e5e7eb'}
            />
          )}

          {/* 패널 */}
          <div
            style={{
              width: isRightSidebarOpen ? `${rightSidebarWidth}px` : '0px',
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: '#ffffff',
              borderLeft: isRightSidebarOpen ? '1px solid #e5e7eb' : 'none',
              overflow: 'hidden',
              transition: 'width 0.25s ease',
            }}
          >
            <div style={{ width: `${rightSidebarWidth}px`, flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
              <LayerPanel />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditorPage;
